import { ChangeDetectionStrategy, Component, OnInit, OnDestroy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Chunk } from '../../interfaces/step/step.interface';
import { Dialog } from '../../interfaces/create-dialog.interface';
import { Notebook } from '../../interfaces/project.interface';
import { AutoUnsubscribe } from '../../decorators/auto-unsubscribe.decorator';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

@AutoUnsubscribe()
@Component({
  standalone: true,
  selector: 'app-chunk-copy-to-dialog',
  templateUrl: './chunk-copy-to-dialog.component.html',
  imports: [
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatSelectModule,
    FlexLayoutModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChunkCopyToDialogComponent implements OnInit, OnDestroy {
  data = inject<Dialog>(MAT_DIALOG_DATA);

  public chunks!: Chunk[];
  public notebooks!: Notebook[];
  public selectedNotebook!: Notebook | undefined;

  ngOnInit() {
    this.chunks = this.data.dialogData.chunks;
    this.notebooks = this.data.dialogData.notebooks;
  }

  // eslint-disable-next-line
  ngOnDestroy() {
    // intentionally empty
  }

  public getChunkName(chunk: Chunk) {
    return chunk.name || `${chunk.stepId} chunk`;
  }

  public selectNotebook(notebook: any) {
    this.selectedNotebook = notebook.value;
  }
}
